import { render, staticRenderFns } from "./AppContentDoctorEdit.vue?vue&type=template&id=545c3411&scoped=true&"
import script from "./AppContentDoctorEdit.vue?vue&type=script&lang=js&"
export * from "./AppContentDoctorEdit.vue?vue&type=script&lang=js&"
import style0 from "./AppContentDoctorEdit.vue?vue&type=style&index=0&id=545c3411&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545c3411",
  null
  
)

export default component.exports